import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Friendly error formatter (handles FastAPI's 422 array shape)
export function formatError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Error desconocido";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  if (typeof detail?.message === "string" && detail.message)
    return detail.message;
  return String(detail);
}
